import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForYou: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconForYou"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 16.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8 8.5H9M7.5 7.5V9.5H9.5V7.5H7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconForYou;
